// Entry point for the build script in your package.json

// Support component names relative to this directory:

import "core-js/stable"

var componentRequireContext = require.context("./components", true)
var ReactRailsUJS = require("react_ujs")
ReactRailsUJS.useContext(componentRequireContext)
